import {
    CREATE_CHALLENGE_PAGE_CHECK_PARTICIPANT,
    CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS,
    CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS_DONE,
    CREATE_CHALLENGE_PAGE_INIT,
    CREATE_CHALLENGE_PAGE_RESET,
    CREATE_CHALLENGE_PAGE_SET_CHALLENGE_TYPE,
    CREATE_CHALLENGE_PAGE_SET_DURATION_END_DATE,
    CREATE_CHALLENGE_PAGE_SET_DURATION_START_DATE,
    CREATE_CHALLENGE_PAGE_SET_DURATION_TYPE,
    CREATE_CHALLENGE_PAGE_SET_PARTICIPANT_TYPE,
    CREATE_CHALLENGE_PAGE_SET_STEP,
    CREATE_CHALLENGE_PAGE_SUBMIT,
    CREATE_CHALLENGE_PAGE_SUBMIT_DONE,
    CREATE_CHALLENGE_PAGE_CLOSE_NOTIFICATION,
    CREATE_CHALLENGE_PAGE_SET_SUMMARY_DIALOG_STATE,
    CREATE_CHALLENGE_PAGE_SET_DISCARD_DIALOG_STATE
} from '../../actions/ActionTypes';
import {
    CREATE_STEP,
    PARTICIPANT_TYPE,
    availableTypes,
    groupChallengeTypes,
    nonWheelchairOnly,
    supportAllTypes,
    wheelchairOnly
} from '../../CreateChallengePage/createChallengePageConstants';
import { durationTypeToDates, getLegalEndDate } from './createChallengePageReducerDurationHelper';
import { wheelchairAvailableTypes } from '../../CreateChallengePage/createChallengePageConstants';

const makeInitialState = () => ({
    /** handlers first init trigger */
    initing: false,
    inited: false,
    createFrom: 'challenge',
    initDisplayName: '',
    initGroupId: null,
    viewerWheelchairMode: null,
    /** step on ui */
    step: CREATE_STEP.TYPE,
    /** challenge types for init with a participant */
    initChallengeTypes: null,
    /** stores available participants */
    participantState: {
        fetching: false,
        error: false,
        /** available wheelchair connections */
        wheelchairConnections: null,
        /** available non-wheelchair connections */
        nonWheelchairConnections: null,
        /** available user connections */
        connections: null,
        /** available user groups */
        groups: null
    },
    editingData: {
        challengeType: null,
        challengeName: null,
        challengeDesc: null,
        participantType: null,
        participantDisplayNames: [],
        participantGroupId: null,
        durationType: null,
        startDate: null,
        endDate: null
    },
    editingDataBackup: null,
    summaryDialogState: {
        open: false,
        dialogType: null
    },
    discardDialogOpen: false,
    submitting: false,
    error: false
});

const INITIAL_STATE = makeInitialState();

/** selectors */

export const selectCreateChallengePage = (state) => state.createChallengePage || INITIAL_STATE;

export const selectCreateChallengePageStep = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.step;
};

export const selectCreateChallengePageEditingData = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.editingData;
};

export const selectCreateChallengePageParticipantState = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    const editingData = selectCreateChallengePageEditingData(state);
    const {
        fetching,
        error,
        wheelchairConnections,
        nonWheelchairConnections,
        connections,
        groups
    } = createChallengePage.participantState;

    let challengeConnections = connections;

    if (wheelchairOnly.includes(editingData.challengeType)) {
        challengeConnections = wheelchairConnections;
    } else if (nonWheelchairOnly.includes(editingData.challengeType)) {
        challengeConnections = nonWheelchairConnections;
    }
    return {
        fetching,
        error,
        connections: challengeConnections,
        fullConnections: connections,
        groups
    };
};

export const selectCreateChallengePageSummaryDialogState = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.summaryDialogState;
};

export const selectCreateChallengePageEditingDataBackup = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.editingDataBackup;
};

export const selectCreateChallengePageIniting = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.initing;
};

export const selectCreateChallengePageInited = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.inited;
};

export const selectCreateChallengePageCreateFrom = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.createFrom;
};

export const selectCreateChallengePageInitDisplayName = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.initDisplayName;
};

export const selectCreateChallengePageSkipParticipant = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    const hasInitConnection = !!createChallengePage.initDisplayName;
    const hasInitGroup = !!createChallengePage.initGroupId;
    return hasInitConnection || hasInitGroup;
};

export const selectCreateChallengePageInitGroupId = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.initGroupId;
};

export const selectCreateChallengePageInitChallengeTypes = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.initChallengeTypes;
};

export const selectCreateChallengePageDiscardDialogOpen = (state) => {
    const createChallengePage = selectCreateChallengePage(state);
    return createChallengePage.discardDialogOpen;
};

/** handlers */

const createChallengePageInit = (_, action) => {
    const initState = makeInitialState();
    initState.createFrom = action.createFrom;
    initState.initDisplayName = action.initDisplayName;
    initState.initGroupId = action.initGroupId;
    initState.initing = true;
    return initState;
};

const createChallengePageReset = () => {
    return INITIAL_STATE;
};

const createChallengePageSetStep = (state, action) => {
    let newParticipantDisplayNames = state.editingData.participantDisplayNames;
    let newParticipantGroupId = state.editingData.participantGroupId;

    if (action.step === CREATE_STEP.SUMMARY) {
        /** clean up illegal participant on summary page */
        if (state.editingData.participantType === PARTICIPANT_TYPE.CONNECTIONS) {
            newParticipantGroupId = null;
        }
        if (state.editingData.participantType === PARTICIPANT_TYPE.GROUP) {
            newParticipantDisplayNames = [];
        }
    }
    return {
        ...state,
        step: action.step,
        error: false,
        editingData: {
            ...state.editingData,
            participantDisplayNames: newParticipantDisplayNames,
            participantGroupId: newParticipantGroupId
        }
    };
};

const createChallengePageSetChallengeType = (state, action) => {
    let newParticipantDisplayNames = state.editingData.participantDisplayNames.slice();

    if (wheelchairOnly.includes(action.challengeType)) {
        const wheelchairConnections = state.participantState.wheelchairConnections || [];
        newParticipantDisplayNames = newParticipantDisplayNames.filter((item) =>
            wheelchairConnections.some((connectionItem) => connectionItem.displayName === item)
        );
    }

    return {
        ...state,
        editingData: {
            ...state.editingData,
            challengeType: action.challengeType,
            challengeName: action.challengeName,
            participantDisplayNames: newParticipantDisplayNames
        }
    };
};

const createChallengePageSetParticipantType = (state, action) => {
    let newChallengeType = state.editingData.challengeType;
    if (action.participantType === PARTICIPANT_TYPE.CONNECTIONS) {
        if (state.viewerWheelchairMode) {
            newChallengeType = wheelchairAvailableTypes.find((item) => item === newChallengeType);
        } else {
            newChallengeType = availableTypes.find((item) => item === newChallengeType);
        }
    }
    return {
        ...state,
        editingData: {
            ...state.editingData,
            participantType: action.participantType,
            challengeType: newChallengeType || null
        }
    };
};

const createChallengePageCheckParticipant = (state, action) => {
    let newParticipantDisplayNames = state.editingData.participantDisplayNames;
    let newParticipantGroupId = state.editingData.participantGroupId;
    if (action.displayName) {
        const hasParticipant = newParticipantDisplayNames.includes(action.displayName);
        if (action.checked) {
            if (!hasParticipant) {
                newParticipantDisplayNames.push(action.displayName);
            }
        } else {
            if (hasParticipant) {
                newParticipantDisplayNames = newParticipantDisplayNames.filter((item) => item !== action.displayName);
            }
        }
    } else if (action.groupId) {
        const hasGroup = state.participantState.groups.some((item) => item.id === action.groupId);
        if (hasGroup) {
            newParticipantGroupId = action.groupId;
        }
    }
    return {
        ...state,
        editingData: {
            ...state.editingData,
            participantDisplayNames: newParticipantDisplayNames,
            participantGroupId: newParticipantGroupId
        }
    };
};

const createChallengePageSetDurationType = (state, action) => {
    const { startDate, endDate } = durationTypeToDates(action.durationType);
    return {
        ...state,
        editingData: {
            ...state.editingData,
            durationType: action.durationType,
            challengeDesc: action.challengeDesc,
            startDate,
            endDate
        }
    };
};

const createChallengePageSetDurationStartDate = (state, action) => {
    const endDate = getLegalEndDate(
        state.editingData.participantType,
        state.editingData.durationType,
        action.startDate,
        state.editingData.endDate
    );
    return {
        ...state,
        editingData: {
            ...state.editingData,
            startDate: action.startDate,
            endDate
        }
    };
};

const createChallengePageSetDurationEndDate = (state, action) => {
    return {
        ...state,
        editingData: {
            ...state.editingData,
            endDate: action.endDate
        }
    };
};

const createChallengePageFetchParticipants = (state) => {
    return {
        ...state,
        participantState: {
            ...state.participantState,
            error: false,
            fetching: true
        }
    };
};

const createChallengePageFetchParticipantsDone = (state, action) => {
    if (action.error) {
        return {
            ...state,
            participantState: {
                ...state.participantState,
                error: true,
                fetching: false
            }
        };
    }

    let initDisplayName = state.initDisplayName;
    let initGroupId = state.initGroupId;
    let initChallengeTypes = state.initChallengeTypes;
    let participantDisplayNames = state.editingData.participantDisplayNames;
    let participantGroupId = state.editingData.participantGroupId;

    const hasConnection = action.connections && action.connections.length > 0;
    const hasGroup = action.groups && action.groups.length > 0;

    const hasOnlyConnection = hasConnection && !hasGroup;
    const hasOnlyGroup = !hasConnection && hasGroup;

    let participantType = null;

    if (hasOnlyConnection) {
        participantType = PARTICIPANT_TYPE.CONNECTIONS;
    }
    if (hasOnlyGroup) {
        participantType = PARTICIPANT_TYPE.GROUP;
    }

    if (!hasConnection) {
        initDisplayName = '';
    }

    if (hasConnection && initDisplayName) {
        const legalInitDisplayName = action.connections.some((item) => {
            return item.displayName === initDisplayName;
        });
        if (legalInitDisplayName) {
            participantType = PARTICIPANT_TYPE.CONNECTIONS;
            participantDisplayNames = [initDisplayName];
            const viewerWheelchairMode = action.wheelchairMode;
            const { initConnection } = action;

            if (viewerWheelchairMode && initConnection.wheelchairModeEnabled) {
                initChallengeTypes = wheelchairAvailableTypes.slice();
            } else if (viewerWheelchairMode && !initConnection.wheelchairModeEnabled) {
                initChallengeTypes = supportAllTypes.slice();
            } else if (!viewerWheelchairMode && initConnection.wheelchairModeEnabled) {
                initChallengeTypes = supportAllTypes.slice();
            } else {
                initChallengeTypes = availableTypes.slice();
            }
        } else {
            initDisplayName = '';
        }
    } else if (hasGroup && initGroupId) {
        const legalInitGroupId = action.groups.some((item) => item.id === initGroupId);
        if (legalInitGroupId) {
            participantType = PARTICIPANT_TYPE.GROUP;
            participantGroupId = initGroupId;
            initChallengeTypes = groupChallengeTypes.slice();
        } else {
            initGroupId = null;
        }
    }

    return {
        ...state,
        initing: false,
        inited: true,
        initDisplayName,
        initGroupId,
        initChallengeTypes,
        viewerWheelchairMode: action.wheelchairMode,
        participantState: {
            ...state.participantState,
            error: false,
            fetching: false,
            wheelchairConnections: action.wheelchairConnections,
            nonWheelchairConnections: action.nonWheelchairConnections,
            connections: action.connections,
            groups: action.groups
        },
        editingData: {
            ...state.editingData,
            participantType,
            participantDisplayNames,
            participantGroupId
        }
    };
};

const createChallengePageSubmit = (state) => {
    return {
        ...state,
        submitting: true,
        error: false
    };
};

const createChallengePageSubmitDone = (state, action) => {
    return {
        ...state,
        submitting: !action.error,
        error: action.error
    };
};

const createChallengePageCloseNotification = (state) => {
    return {
        ...state,
        error: false
    };
};

const createChallengePageSetSummaryDialogState = (state, action) => {
    let newEditingData = state.editingData;
    let newEditingDataBackup = null;

    if (action.open) {
        /** dialog open, backup */
        newEditingDataBackup = {
            ...state.editingData,
            participantDisplayNames: state.editingData.participantDisplayNames.slice()
        };
    } else {
        /** don't change */
        if (!action.commit) {
            newEditingData = state.editingDataBackup;
        }
    }

    return {
        ...state,
        summaryDialogState: {
            open: action.open,
            dialogType: action.open ? action.dialogType : state.summaryDialogState.dialogType
        },
        editingData: newEditingData,
        editingDataBackup: newEditingDataBackup
    };
};

const createChallengePageSetDiscardDialogState = (state, action) => {
    return {
        ...state,
        discardDialogOpen: action.open
    };
};

const handlers = {
    [CREATE_CHALLENGE_PAGE_INIT]: createChallengePageInit,
    [CREATE_CHALLENGE_PAGE_RESET]: createChallengePageReset,
    [CREATE_CHALLENGE_PAGE_SET_STEP]: createChallengePageSetStep,
    [CREATE_CHALLENGE_PAGE_SET_CHALLENGE_TYPE]: createChallengePageSetChallengeType,
    [CREATE_CHALLENGE_PAGE_SET_PARTICIPANT_TYPE]: createChallengePageSetParticipantType,
    [CREATE_CHALLENGE_PAGE_SET_DURATION_TYPE]: createChallengePageSetDurationType,
    [CREATE_CHALLENGE_PAGE_SET_DURATION_START_DATE]: createChallengePageSetDurationStartDate,
    [CREATE_CHALLENGE_PAGE_SET_DURATION_END_DATE]: createChallengePageSetDurationEndDate,
    [CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS]: createChallengePageFetchParticipants,
    [CREATE_CHALLENGE_PAGE_FETCH_PARTICIPANTS_DONE]: createChallengePageFetchParticipantsDone,
    [CREATE_CHALLENGE_PAGE_CHECK_PARTICIPANT]: createChallengePageCheckParticipant,
    [CREATE_CHALLENGE_PAGE_SUBMIT]: createChallengePageSubmit,
    [CREATE_CHALLENGE_PAGE_SUBMIT_DONE]: createChallengePageSubmitDone,
    [CREATE_CHALLENGE_PAGE_CLOSE_NOTIFICATION]: createChallengePageCloseNotification,
    [CREATE_CHALLENGE_PAGE_SET_SUMMARY_DIALOG_STATE]: createChallengePageSetSummaryDialogState,
    [CREATE_CHALLENGE_PAGE_SET_DISCARD_DIALOG_STATE]: createChallengePageSetDiscardDialogState
};

export default function createChallengePageReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) {
        return state;
    }
    return handler(state, action);
}
